import { useState, useEffect } from 'react';
import { useUserSettings } from '../../utils/use-user-settings';
import {
  EnterpriseUpsellPageKey,
  enterpriseUpsellPages,
} from './enterprise-pages-with-landing-page-enum';

import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

interface EnterpriseFallbackPagesProps {
  initialPage: 'Rules Engine' | 'gPanel API';
}

export default function EnterpriseFallbackPages({
  initialPage,
}: EnterpriseFallbackPagesProps) {
  const [activeTab, setActiveTab] =
    useState<EnterpriseUpsellPageKey>(initialPage);

  useEffect(() => {
    setActiveTab(initialPage);
  }, [initialPage]);

  const { marketingOverview } = useUserSettings();
  const heightOfMarketingOverview = marketingOverview ? 48 : 0;

  const getTabSx = (tabValue: EnterpriseUpsellPageKey) => ({
    textTransform: 'none',
    fontWeight: activeTab === tabValue ? 600 : 500,
    fontSize: 15,
  });

  const ActivePage = enterpriseUpsellPages.find(
    (page) => page.key === activeTab
  )?.Component;

  return (
    <Box
      sx={{
        width: '100%',
        height: `calc(100vh - 75px - ${heightOfMarketingOverview}px)`,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          px: 4,
          pt: 2.2,
          bgcolor: 'transparent',
          zIndex: 10,
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          aria-label="Enterprise Fallback Features"
          textColor="primary"
          indicatorColor="primary"
        >
          {enterpriseUpsellPages.map(({ key, label }) => (
            <Tab key={key} value={key} label={label} sx={getTabSx(key)} />
          ))}
        </Tabs>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {ActivePage && <ActivePage />}
      </Box>
    </Box>
  );
}
